import React, { useContext, useEffect, useState, useRef, useMemo } from "react";
import HeadingBanner, {
  HeadingBanner2,
} from "../../Components/HeadingBanner.jsx";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Product_List_fun,
  Product_List_fun_notlogin,
  getGender_fun,
} from "../../api/Pageapi.js";
import { Image, Shimmer } from "react-shimmer";
import "aos/dist/aos.css";
import AOS from "aos";
import { Logindetail } from "../../context/Logindetail.js";
import instance from "../../Config/Config.js";
import { GiRing } from "react-icons/gi";
import { FaSearch } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination, Grid, Autoplay } from "swiper/modules";
import {
  FaFolderOpen,
  FaTimes,
  FaChevronDown,
  FaChevronUp,
  FaHeart,
  FaRegHeart,
  FaShoppingCart,
  FaFilter,
} from "react-icons/fa";
import { HiOutlineShoppingCart } from "react-icons/hi";
import { Addtocart_fun } from "../../api/Scheme2.js";
import {
  AddtoWishlist_fun,
  RemoveWishlist_fun,
  CheckWishlist_fun,
} from "../../api/wishlist_api.js";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { setCount, setWishlistCount } from "../../store/slices/counterSlice";
import { GenderApi } from "../../api/Controllapi.js";
import { GetWishlist_fun } from "../../api/wishlist_api.js";



// export default function ProductList({ image }) {
//   const router = useNavigate();
//   const [response, setResponse] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [isLoading2, setIsLoading2] = useState(true);
//   const { detail_info, token } = useContext(Logindetail);
//   const location = useLocation();
//   const { categoryId, subcategoryId } = location.state || {};

//   // Pagination State
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 12;

//   // Get products based on category or subcategory
//   const getProductApi = () => {
//     setIsLoading(true);

//     const promise =
//       token && detail_info
//         ? Product_List_fun({ user_id: detail_info.id })
//         : Product_List_fun_notlogin();

//     promise
//       .then((res) => {
//         setResponse(Array.isArray(res?.data) ? res.data : []);
//       })
//       .catch((err) => {
//         console.log(err);
//         setResponse([]); 
//       })
//       .finally(() => {
//         setIsLoading(false);
//         setIsLoading2(false);
//       });
//   };

//   useEffect(() => {
//     if (categoryId || subcategoryId) {
//       getProductApi(categoryId, subcategoryId);
//     } else {
//       getProductApi();
//     }
//   }, [categoryId, subcategoryId]);

// //newly added pagination fun
//   const indexOfLastProduct = currentPage * itemsPerPage;
//   const indexOfFirstProduct = indexOfLastProduct - itemsPerPage;
//   const currentProducts = response.slice(indexOfFirstProduct, indexOfLastProduct);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const totalPages = Math.ceil(response.length / itemsPerPage);

//   useEffect(() => {
//     AOS.init({ duration: 1500 });
//   }, []);

//   return (
//     <>
//       <HeadingBanner2 image={image} />

//       {/* Categories and Search */}
//       <div className="categorycondesign search-wrapper">
//         {/* Your existing code for search and categories... */}
//       </div>

//       <section className="product-list-page">
//         <div className="container">
//           <div className="row">
//             {isLoading ? (
//               // Display loading placeholders
//               Array.from({ length: 6 }).map((_, i) => (
//                 <div className="col-lg-4 col-md-6 col-sm-6 col-12 mb-4" key={i}>
//                   <div className="gp_lst border">
//                     <div className="mb-3 d-flex justify-content-center pl-img">
//                       <Shimmer width={200} height={200} className="rounded" />
//                     </div>
//                     <div className="d-flex flex-column gap-3 justify-content-center text-center">
//                       <h5 className="fw-bold pl-imgname">
//                         <Shimmer width={350} height={24} className="rounded" />
//                       </h5>
//                       <h6 className="text-color2 fw-bold text-center d-flex justify-content-center">
//                         <Shimmer className="rounded" width={100} height={19} />
//                       </h6>
//                       <div className="d-flex justify-content-center">
//                         <Shimmer width={160} height={50} className="rounded" />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))
//             ) : currentProducts.length > 0 ? (
//               currentProducts.map((product, i) => (
//                 <div className="col-lg-4 col-sm-6 mb-4" key={i}>
//                   <div>
//                     <div className="gp_lst border">
//                       <div className="mb-3 d-flex justify-content-center pd-view">
//                         <img src={product?.image} alt={product?.name} />
//                       </div>
//                       <div className="d-flex flex-column gap-3 justify-content-center text-center">
//                         <h5 className="fw-bold one_line">{product?.name}</h5>
//                         <h6 className="text-color fw-bold">
//                           {Number(product?.final_prices).toLocaleString('en-IN', {
//                             style: 'currency',
//                             currency: 'INR',
//                             minimumFractionDigits: 2,
//                           })}
//                         </h6>
//                         <div>
//                           <button
//                             type="button"
//                             onClick={() =>
//                               router(`/detail/${product.slug}`, {
//                                 state: {
//                                   id: product.id,
//                                   finalPrice: product?.final_prices,
//                                 },
//                               })
//                             }
//                             className="btn"
//                           >
//                             View Details
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <div className="w-100 d-flex justify-content-space-evenly flex-column align-items-center">
//                 <img src="/assets/noData.png" alt="No Data" className="w-25" />
//                 <h4>No Products found</h4>
//               </div>
//             )}
//           </div>

//           {/* Pagination Controls */}
//           <div className="d-flex justify-content-center mt-4">
//             <button
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//               className="btn btn-light me-2"
//             >
//               Previous
//             </button>

//             {[...Array(totalPages).keys()].map((pageNumber) => (
//               <button
//                 key={pageNumber}
//                 onClick={() => handlePageChange(pageNumber + 1)}
//                 className={`btn btn-light me-2 ${currentPage === pageNumber + 1 ? 'active' : ''}`}
//               >
//                 {pageNumber + 1}
//               </button>
//             ))}

//             <button
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//               className="btn btn-light ms-2"
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// }


export default function ProductList({ image }) {
  const router = useNavigate();
  const dispatch = useDispatch();

  const getImageUrl = (imagePath) => {
    if (!imagePath) return "/assets/images/placeholder_img.jfif";
    if (String(imagePath).startsWith("http")) return imagePath;

    const base_url_env = process.env.REACT_APP_BASE_URL || "";
    // If base URL has /api/v1/, remove it to get the site root for public/ assets
    const baseUrl = base_url_env.replace("/api/v1/", "/");
    return `${baseUrl}${imagePath}`;
  };

  const handleAddToCart = async (product) => {
    if (!token || !detail_info) {
      localStorage.setItem(
        "pendingCartAction",
        JSON.stringify({
          item_id: product.id,
          quantity: 1,
        })
      );
      // Set Role 2 (Customer) and trigger modal
      localStorage.setItem("roleType", "2");
      const loginRole = document.getElementById("loginRole");
      if (loginRole) loginRole.value = "2";
      document.getElementById("openLoginModalNow")?.click();
      return;
    }

    if (product.cart) {
      toast.success("Already in Cart");
      return;
    }

    try {
      const res = await Addtocart_fun({
        item_id: product.id,
        quantity: 1,
      });
      if (res?.result === false) {
        toast.error(res?.message || "Failed to add to cart");
      } else {
        toast.success("Added to Cart");
        // Update local state to reflect item is in cart
        setresponse(prev =>
          prev.map(p =>
            p.id === product.id ? { ...p, cart: true } : p
          )
        );
        // Update cart count
        const responseApi = await instance.get(`get_cart_list`);
        const itemCount = responseApi?.data?.carts?.length || 0;
        dispatch(setCount(itemCount));
      }
    } catch (error) {
  console.error("Cart error:", error);

  if (error.response) {
    // Server responded with a status (e.g., 400)
    const apiMessage =
      error.response.data?.message ||
      error.response.data?.error ||
      "Request failed";

    toast.error(apiMessage);
    router(`/detail/${product.slug}`, {
      state: {
        id: product.id,
        finalPrice: product?.final_prices,
      },
    });
  } else if (error.request) {
    // Request made but no response
    toast.error("No response from server");
  } else {
    // Something else
    toast.error(error.message || "Something went wrong");
    router(`/detail/${product.slug}`, {
      state: {
        id: product.id,
        finalPrice: product?.final_prices,
      },
    });
  }
}
  };

  const handleWishlist = async (product) => {
    if (!token || !detail_info) {
      // Set Role 2 (Customer) and trigger modal
      localStorage.setItem("roleType", "2");
      const loginRole = document.getElementById("loginRole");
      if (loginRole) loginRole.value = "2";
      document.getElementById("openLoginModalNow")?.click();
      return;
    }

    const isRemoving = product.wishlist === 1 || product.wishlist === true;
    try {
      const res = isRemoving
        ? await RemoveWishlist_fun(product.id)
        : await AddtoWishlist_fun(product.id);

      if (res?.status === 200 || res?.status === true) {
        toast.success(res?.message || (isRemoving ? "Removed from Wishlist" : "Added to Wishlist"));
        setresponse(prev => prev.map(p =>
          p.id === product.id ? { ...p, wishlist: !isRemoving } : p
        ));

        // Refresh wishlist count
        const wishlistRes = await GetWishlist_fun();
        dispatch(setWishlistCount(wishlistRes?.data?.length || 0));
      } else {
        toast.error(res?.message || "Failed to update wishlist");
      }
    } catch (error) {
      console.error("Wishlist error:", error);
      toast.error("Something went wrong");
    }
  };

  const [response, setresponse] = useState([]);
  const [Isloading, setIsloading] = useState(true);
  const [Isloading2, setIsloading2] = useState(true);
  const { detail_info, token } = useContext(Logindetail);
  const [totalPages, setTotalPages] = useState(1)
  const isFirstLoad = useRef(true);
  const [showAllCategories, setShowAllCategories] = useState(false);
  const [totalResults, setTotalResults] = useState(0);
  const [filters, setFilters] = useState({
    categories: [],
    gender_ids: [],
    onDiscount: false,
    priceRange: [],
    weightRange: [],
    metalColor: [],
    metalPurity: []
  });
  const [genders, setGenders] = useState([]);
  const [dynamicFilters, setDynamicFilters] = useState(null);
  const [showFilter, setShowFilter] = useState(false);

  const handleClearFilters = () => {
    setFilters({
      categories: [],
      gender_ids: [],
      onDiscount: false,
      priceRange: [],
      weightRange: [],
      metalColor: [],
      metalPurity: []
    });
    setCurrentPage(1);
  };

  const location = useLocation();

  const [categoryId, setCategoryId] = useState(() => {
    if (location.pathname === "/gold") return 3;
    if (location.pathname === "/silver") return 8;
    return location.state?.categoryId || null;
  });
  const [subcategoryId, setSubcategoryId] = useState(location.state?.subcategoryId || null);

  const isRefresh = location.key === "default";

  //added for pagination---
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 24;

  const [sortBy, setSortBy] = useState("id_desc");

  const sort_options = [
    { label: "Newest First", value: "id_desc" },
    { label: "Price: Low to High", value: "price_asc" },
    { label: "Price: High to Low", value: "price_desc" }
  ];



  // useEffect(() => {
  //   if (categoryId || subcategoryId) {
  //     getproduct_api2(categoryId, subcategoryId, currentPage);
  //   } else {
  //     getproduct_api(currentPage);
  //   }
  // }, [categoryId, subcategoryId]);

  useEffect(() => {
    if (location.pathname === "/gold") {
      setCategoryId(3);
      setSubcategoryId(null);
      // setCurrentPage(1);
    } else if (location.pathname === "/silver") {
      setCategoryId(8);
      setSubcategoryId(null);
      // setCurrentPage(1);
    } else if (location.state?.categoryId) {
      setCategoryId(location.state.categoryId);
      setSubcategoryId(location.state.subcategoryId || null);
      // setCurrentPage(1);
    }
  }, [location.pathname, location.state]);

  useEffect(() => {
    fetchProducts(currentPage);
  }, [categoryId, subcategoryId, currentPage, filters, sortBy]);

  const fetchProducts = (pageNumber = 1) => {
    setIsloading(true);

    // Construct params from filters
    const params = {
      user_id: detail_info?.id,
      page_no: pageNumber,
      limit: '24',
      category_id: categoryId,
      sub_category_id: subcategoryId || filters.categories.join(','),
      gender_id: filters.gender_ids.join(','),
      discount: filters.onDiscount ? 1 : 0,
      price_range: filters.priceRange.join(','),
      gram_range: filters.weightRange.join(','),
      metal_color: filters.metalColor.join(','),
      metal_purity: filters.metalPurity.join(','),
      sort: sortBy,
    };

    const promise = token && detail_info
      ? Product_List_fun(params)
      : Product_List_fun_notlogin(params);

    promise
      .then((res) => {
        setresponse(Array.isArray(res?.data) ? res.data : []);
        setTotalPages(res?.pagination?.last_page || 1);
        setTotalResults(res?.pagination?.total || (res?.data?.length || 0));
        if (res?.filters) {
          setDynamicFilters(res.filters);
        }
      })
      .catch((err) => {
        console.error(err);
        setresponse([]);
      })
      .finally(() => {
        setIsloading(false);
        setIsloading2(false);
      });
  };

  useEffect(() => {
    // Clear location state after using it
    if (location.state) {
      window.history.replaceState({}, document.title); // removes state from history
    }
  }, []);


  //newly added pagination fun
  // const indexOfLastProduct = currentPage * itemsPerPage;
  // const indexOfFirstProduct = indexOfLastProduct - itemsPerPage;
  // const currentProducts = response.slice(indexOfFirstProduct, indexOfLastProduct);

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;

    setCurrentPage(pageNumber); // update state for UI
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    if (categoryId || subcategoryId) {
      getproduct_api2(categoryId, subcategoryId, pageNumber);
    } else {
      getproduct_api(pageNumber);
    }
  };



  // const totalPages = Math.ceil(response.length / itemsPerPage);



  const getproduct_api = (pageNumber = 1, categoryId, subcategoryId) => {
    setIsloading(true);


    const promise =
      token && detail_info
        ? Product_List_fun({
          user_id: detail_info.id,
          page_no: pageNumber,
          limit: '24'
        })
        : Product_List_fun_notlogin({ page_no: pageNumber, category_id: categoryId, sub_category_id: subcategoryId, limit: '24' });

    promise
      .then((res) => {
        setresponse(Array.isArray(res?.data) ? res.data : []);
        setTotalPages(res?.pagination?.last_page || 1);

      })
      .catch((err) => {
        setresponse([]); // clear response on error
      })
      .finally(() => {
        setIsloading(false);
        setIsloading2(false);
      });
  };

  const getproduct_api2 = (categoryId, subcategoryId, pageNumber = 1) => {
    setIsloading(true);

    const promise =
      token && detail_info
        ? Product_List_fun({
          user_id: detail_info.id,
          category_id: categoryId ? categoryId : "",
          sub_category_id: subcategoryId && subcategoryId,
          page_no: pageNumber,
          limit: '24'
        })
        : Product_List_fun_notlogin({ page_no: pageNumber, category_id: categoryId, sub_category_id: subcategoryId, limit: '24' });

    promise
      .then((res) => {
        setresponse(Array.isArray(res?.data) ? res.data : []);
        setTotalPages(res?.pagination?.last_page || 1);
      })
      .catch((err) => {
        setresponse([]); // clear response on error
      })
      .finally(() => {
        setIsloading(false);
        setIsloading2(false);
      });
  };

  // useEffect(() => {
  //   getproduct_api();
  // }, []);

  useEffect(() => {
    AOS.init({
      duration: 1500,
    });
  }, []);

  const [category, setcategoryList] = useState([]);

  const subcategoriesList = useMemo(() => {
    if (categoryId) {
      const activeCat = category.find(cat => cat.id === Number(categoryId));
      return activeCat ? (activeCat.sub_categories || []) : [];
    }
    return category.flatMap(cat => cat.sub_categories || []);
  }, [category, categoryId]);

  const GetCheckoutList = async () => {
    try {
      const responseApi = await instance.get(`category`);
      // console.log("responseApi", responseApi?.data?.category);
      setcategoryList(responseApi?.data?.category);
    } catch (error) {
      console.error(
        "Error fetching cart:",
        error.response?.data || error.message
      );
    }
  };

  useEffect(() => {
    GetCheckoutList();
    fetchGenders();
  }, []);

  const fetchGenders = async () => {
    try {
      const res = await GenderApi();
      setGenders(Array.isArray(res?.data) ? res.data : []);
    } catch (error) {
      console.error("Error fetching genders:", error);
    }
  };

  const [showCategories, setShowCategories] = useState(false);
  const navigate = useNavigate();



  return (
    <>
      {(location.pathname !== "/gold" && location.pathname !== "/silver") && (
        <div className="categorycondesign search-wrapper ">
          <div className="container pb-2 pt-2 d-flex justify-content-center">

            {Isloading2 ? (
              <></>
            ) : (
              <>
                <div className="d-lg-none mb-2">
                  <button
                    className="btn btn-outline-gold d-flex align-items-center gap-2"
                    onClick={() => setShowCategories(!showCategories)}
                  >
                    {showCategories ? (
                      <>
                        <FaTimes />
                      </>
                    ) : (
                      <>
                        <span>Categories</span>
                        <FaChevronDown />
                      </>
                    )}
                  </button>
                </div>

                <div
                  className={`category-scroll-container gap-4 ${showCategories ? "d-flex" : "d-none"
                    } d-lg-flex`}
                >
                  {category.map((cat) => (
                    <div key={cat.id} className="category-item position-relative">
                      <div
                        className="d-flex align-items-center category-button px-3 py-2"
                        onClick={() => getproduct_api2(cat.id)}
                      >
                        <img
                          src={cat.image || "/assets/images/green.png"}
                          alt={cat.name}
                          width="24"
                          height="24"
                          className="me-2"
                          style={{ borderRadius: "3px", objectFit: "cover" }}
                        />
                        <span className="category-text small">{cat.name}</span>
                      </div>

                      {cat.sub_categories?.length > 0 && (
                        <div className="subcategory-dropdown">
                          <ul className="list-unstyled m-0 p-2 ">
                            {cat.sub_categories.map((sub) => (
                              <li
                                key={sub.id}
                                className="py-1 px-2 sub-item text-truncate-custom"
                                onClick={() => getproduct_api2(cat.id, sub.id, 1)}
                              >
                                <GiRing color="#FFD700" className="me-3" />
                                {sub.name}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      )}

      <HeadingBanner2 image={image} />

      {/* {
          Isloading ? (
            <div className='says_c'>
              <div className="container">
                <Swiper
                  spaceBetween={10}
                  slidesPerView={3}
                  freeMode={true}
                  loop={true}
                  autoplay={{
                    delay: 2500, // delay between slides in ms
                    disableOnInteraction: false, // to ensure autoplay continues after interaction
                  }}
                  breakpoints={{
                    320: {
                      slidesPerView: 1
                    },
                    576: {
                      slidesPerView: 2
                    },
                    992: {
                      slidesPerView: 2
                    },
                    1200: {
                      slidesPerView: 3
                    }
                  }}
                  pagination={{
                    clickable: true,
                  }}
                  modules={[FreeMode, Pagination, Autoplay]}
                  onSlideChange={() => console.log("slide change")}
                  onSwiper={(swiper) => console.log(swiper)}
                  className="main_slider"
                >
                  {
                    Array.from({ length: 5 }).map((_, i) => {
                      return (
                        <SwiperSlide>
                          <div className='pshycal h-100 border client-shim' key={i}>
                            <div className='d-flex gap-2 align-items-center mb-3'>
                              <div className='border-circle'><Shimmer className='rounded' width={50} height={50} /></div>
                              <div>
                                <h5 className='fw-bold'><Shimmer className='rounded' width={60} height={20} /></h5>
                                <h6><Shimmer className='rounded' width={60} height={20} /></h6>
                              </div>
                            </div>
                            <p className='lh-base'><Shimmer className='rounded' width={300} height={70} /></p>
                          </div>
                        </SwiperSlide>
                      )
                    })
                  }


                </Swiper>
              </div>
            </div>
          ) : (

            <div className='says_c'>
              <div className="container">
                <Swiper
                  spaceBetween={10}
                  slidesPerView={3}
                  freeMode={true}
                  loop={true}
                  autoplay={{
                    delay: 2500, // delay between slides in ms
                    disableOnInteraction: false, // to ensure autoplay continues after interaction
                  }}
                  breakpoints={{
                    320: {
                      slidesPerView: 1
                    },
                    576: {
                      slidesPerView: 2
                    },
                    992: {
                      slidesPerView: 2
                    },
                    1200: {
                      slidesPerView: 3
                    }
                  }}
                  pagination={{
                    clickable: true,
                  }}
                  modules={[FreeMode, Pagination, Autoplay]}
                  onSlideChange={() => console.log("slide change")}
                  onSwiper={(swiper) => console.log(swiper)}
                  className="main_slider"
                >
                  {
                    category.map((data, i) => {
                      return (
                        <SwiperSlide key={i}>
                          <div className='pshycal h-100 border'>
                            <div className='d-flex gap-2 align-items-center mb-3'>
                              <img src={data?.image} className='rounded-circle' alt='' />
                              <div>
                                <h5 className='fw-bold'>{data?.name}</h5>

                              </div>
                            </div>

                          </div>
                        </SwiperSlide>
                      )
                    })
                  }
                </Swiper>
              </div>
            </div>

          )
        } */}

      {/* <div className="container my-4 mt-5 d-flex justify-content-center">
        {Isloading ? (
          <p>Loading...</p>
        ) : (
          <div className="d-flex flex-wrap gap-4">
            {category.map((cat) => (
              <div key={cat.id} className="category-item position-relative">
                <div
                  className="d-flex align-items-center category-button px-3 py-2"
                  onClick={() => getproduct_api2(cat.id)}
                >
                  <img
                    // src={cat.image || "/assets/images/green.png"}
                    src={"/assets/images/green.png"}
                    alt={cat.name}
                    width="24"
                    height="24"
                    className="me-2"
                    style={{ borderRadius: "3px", objectFit: "cover" }}
                  />
                  <span className="category-text small ">{cat.name}</span>
                </div>


                {cat.sub_categories?.length > 0 && (
                  <div className="subcategory-dropdown">
                    <ul className="list-unstyled m-0 p-2">
                      {cat.sub_categories.map((sub) => (
                        <li
                          key={sub.id}
                          className=" py-1 px-2 sub-item"
                          onClick={() => getproduct_api2(sub.id)}
                        >
                          <GiRing color="#FFD700" />
                          {sub.name}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div> */}

      <section className="product-list-page">
        <div className="container-fluid px-md-5 px-3">
          {/* Breadcrumbs and Results Heading */}
          <div className="product-list-header mb-4">
            <nav aria-label="breadcrumb">
              <div className="d-flex align-items-center gap-2 mb-2" style={{ fontSize: "14px", color: "#333" }}>
                <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }} style={{ color: "#333", textDecoration: "none" }}>Home</a>
                <span className="text-muted" style={{ fontSize: "12px" }}>&gt;</span>
                <span style={{ fontWeight: "400" }}>
                  {categoryId === 3 ? "Gold Jewellery" : categoryId === 8 ? "Silver Jewellery" : "Product Gallery"}
                </span>
              </div>
            </nav>

            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
              <div>
                <div className="d-flex align-items-baseline gap-2 flex-nowrap">
                  <h1 className="fw-bold mb-0 text-nowrap" style={{ fontSize: "20px", color: "#333" }}>
                    {categoryId === 3 ? "Gold Jewellery" : categoryId === 8 ? "Silver Jewellery" : "Product Gallery"}
                  </h1>
                  <span className="text-muted text-nowrap" style={{ fontSize: "16px" }}>
                    ( {response.length} items out of {totalResults} items )
                  </span>
                </div>
                <div className="mt-2" style={{ color: "#999", fontSize: "18px" }}>
                  {totalResults} Results
                </div>
              </div>

              <div className="d-flex align-items-center gap-2 sort-wrapper w-100 justify-content-between justify-content-md-end">
                <button
                  className="btn btn_filter_mobile d-lg-none d-flex align-items-center gap-2"
                  onClick={() => setShowFilter(true)}
                  style={{
                    backgroundColor: "#fff",
                    border: "2px solid #ddd",
                    borderRadius: "8px",
                    padding: "8px 16px",
                    fontWeight: "600",
                    fontSize: "14px",
                    color: "#333"
                  }}
                >
                  <FaFilter /> Filter
                </button>
                <div className="d-flex align-items-center gap-2">
                  <span className="text-muted small fw-bold text-uppercase">Sort By:</span>
                  <select
                    className="form-select sort-select"
                    value={sortBy}
                    onChange={(e) => {
                      setSortBy(e.target.value);
                      setCurrentPage(1);
                    }}
                    style={{
                      width: "160px",
                      borderRadius: "8px",
                      border: "2px solid #ddd",
                      padding: "8px 12px",
                      fontSize: "14px",
                      cursor: "pointer",
                      outline: "none"
                    }}
                  >
                    {sort_options.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {/* Backdrop for mobile */}
            {showFilter && <div className="filter-overlay" onClick={() => setShowFilter(false)}></div>}

            {/* Sidebar Filters */}
            <div className={`col-lg-2 filter-sidebar-wrapper ${showFilter ? "show" : ""}`}>
              <div className="filter-sidebar">
                <div className="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
                  <h4 className="fw-bold mb-0">Filters</h4>
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn btn-sm text-danger fw-bold p-0 border-0"
                      onClick={handleClearFilters}
                      style={{ fontSize: "13px" }}
                    >
                      Clear All
                    </button>
                    <button className="btn p-0 border-0 d-lg-none" onClick={() => setShowFilter(false)}>
                      <FaTimes size={20} />
                    </button>
                  </div>
                </div>

                {/* Materials */}
                {dynamicFilters?.materials && (
                  <div className="filter-section">
                    <h5>Metals</h5>
                    {dynamicFilters.materials.map(m => (
                      <div className="filter-item" key={m.id}>
                        <input
                          type="checkbox"
                          id={`material-${m.id}`}
                          checked={filters.metalPurity.includes(m.id.toString())}
                          onChange={(e) => {
                            const val = m.id.toString();
                            setFilters(prev => ({
                              ...prev,
                              metalPurity: e.target.checked
                                ? [...prev.metalPurity, val]
                                : prev.metalPurity.filter(item => item !== val)
                            }));
                          }}
                        />
                        <label htmlFor={`material-${m.id}`}>{m.label}</label>
                      </div>
                    ))}
                  </div>
                )}

                {/* Gender */}
                {dynamicFilters?.genders && (
                  <div className="filter-section">
                    <h5>Gender</h5>
                    {dynamicFilters.genders.map(option => (
                      <div className="filter-item" key={option.id}>
                        <input
                          type="checkbox"
                          id={`gender-${option.id}`}
                          checked={filters.gender_ids.includes(option.id.toString())}
                          onChange={(e) => {
                            const val = option.id.toString();
                            setFilters(prev => ({
                              ...prev,
                              gender_ids: e.target.checked
                                ? [...prev.gender_ids, val]
                                : prev.gender_ids.filter(o => o !== val)
                            }));
                          }}
                        />
                        <label htmlFor={`gender-${option.id}`}>{option.label}</label>
                      </div>
                    ))}
                  </div>
                )}

                {/* Discount */}
                {dynamicFilters?.discount && (
                  <div className="filter-section">
                    <h5>Discount</h5>
                    {dynamicFilters.discount.map((d, idx) => (
                      <div className="filter-item" key={idx}>
                        <input
                          type="checkbox"
                          id={`disc-${idx}`}
                          checked={filters.onDiscount}
                          onChange={(e) => setFilters(prev => ({ ...prev, onDiscount: e.target.checked }))}
                        />
                        <label htmlFor={`disc-${idx}`}>{d.label}</label>
                      </div>
                    ))}
                  </div>
                )}

                {/* Price Range */}
                {dynamicFilters?.price_ranges && (
                  <div className="filter-section">
                    <h5>Price Range</h5>
                    {dynamicFilters.price_ranges.map((range, idx) => (
                      <div className="filter-item" key={idx}>
                        <input
                          type="checkbox"
                          id={`price-${idx}`}
                          checked={filters.priceRange.includes(range.value)}
                          onChange={(e) => {
                            setFilters(prev => ({
                              ...prev,
                              priceRange: e.target.checked ? [range.value] : []
                            }));
                          }}
                        />
                        <label htmlFor={`price-${idx}`}>{range.label}</label>
                      </div>
                    ))}
                  </div>
                )}

                {/* Weight Range */}
                {dynamicFilters?.gram_ranges && (
                  <div className="filter-section">
                    <h5>Weight Range</h5>
                    {dynamicFilters.gram_ranges.map((w, idx) => (
                      <div className="filter-item" key={idx}>
                        <input
                          type="checkbox"
                          id={`weight-${idx}`}
                          checked={filters.weightRange.includes(w.value)}
                          onChange={(e) => {
                            setFilters(prev => ({
                              ...prev,
                              weightRange: e.target.checked
                                ? [...prev.weightRange, w.value]
                                : prev.weightRange.filter(item => item !== w.value)
                            }));
                          }}
                        />
                        <label htmlFor={`weight-${idx}`}>{w.label}</label>
                      </div>
                    ))}
                  </div>
                )}

                {/* Metal Color */}
                {dynamicFilters?.metal_colours && (
                  <div className="filter-section">
                    <h5>Metal Color</h5>
                    {dynamicFilters.metal_colours.map(color => (
                      <div className="filter-item" key={color.id}>
                        <input
                          type="checkbox"
                          id={`color-${color.id}`}
                          checked={filters.metalColor.includes(color.id.toString())}
                          onChange={(e) => {
                            const val = color.id.toString();
                            setFilters(prev => ({
                              ...prev,
                              metalColor: e.target.checked
                                ? [...prev.metalColor, val]
                                : prev.metalColor.filter(c => c !== val)
                            }));
                          }}
                        />
                        <label htmlFor={`color-${color.id}`}>{color.label}</label>
                      </div>
                    ))}
                  </div>
                )}

              </div>
            </div>

            {/* Product Grid */}
            <div className="col-lg-10 col-12">
              <div className="row">
                {Isloading ? (
                  Array.from({ length: 6 }).map((_, i) => (
                    <div
                      className="col-lg-3  col-md-6 col-sm-6 col-12  mb-4"
                      key={i}
                    >
                      <div className="gp_lst border">
                        <div className="mb-3 d-flex justify-content-center pl-img">
                          <Shimmer width={200} height={200} className="rounded" />
                        </div>

                        <div className="d-flex flex-column gap-3 justify-content-center text-center">
                          <h5 className="fw-bold pl-imgname">
                            <Shimmer width={350} height={24} className="rounded" />
                          </h5>
                          <h6 className="text-color2 fw-bold text-center d-flex justify-content-center">
                            <Shimmer className="rounded" width={100} height={19} />
                          </h6>
                          <div className="d-flex justify-content-center">
                            <Shimmer width={160} height={50} className="rounded" />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : response.length > 0 ? (
                  response.filter(product => !filters.onDiscount || product.before_discount).map((product, i) => (
                    <div className="col-xxl-3 col-lg-4 col-sm-6 mb-4" key={i}>
                      <div
                        onClick={() =>
                          router(`/detail/${product.slug}`, {
                            state: {
                              id: product.id,
                              finalPrice: product?.final_prices,
                            },
                          })
                        }
                      >
                        <div className="gp_lst border">
                          {product?.is_sold == 1 && (
                            <div className="sold-out-stamp">Sold Out</div>
                          )}
                          {product?.before_discount > 0 && (
                            <div className="offer-ribbon">On Offer</div>
                          )}

                          <div className={product?.is_sold == 1 ? "product-sold-out-content" : ""}>
                            <button
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleWishlist(product);
                              }}
                              className="wishlist-btn-float"
                              title={product?.wishlist ? "Remove from Wishlist" : "Add to Wishlist"}
                            >
                              {product?.wishlist ? <FaHeart style={{ color: "#650020" }} /> : <FaRegHeart />}
                            </button>

                            <div className="mb-3 d-flex justify-content-center pd-view">
                              <img src={getImageUrl(product?.image)} alt={product?.name} />
                            </div>

                            <div className="d-flex flex-column gap-1 justify-content-center">
                              <h5 className="fw-bold one_line text-start px-2 mb-1" style={{ fontSize: "16px" }}>
                                {product?.name}
                              </h5>

                              <div className="d-flex flex-column align-items-start px-2">
                                <h6 className="mb-0" style={{
                                  textDecoration: "line-through",
                                  color: "#888",
                                  fontSize: "13px",
                                  visibility: product?.before_discount > 0 ? "visible" : "hidden"
                                }}>
                                  {product?.before_discount > 0
                                    ? Number(product?.before_discount).toLocaleString('en-IN', {
                                      style: 'currency',
                                      currency: 'INR',
                                      minimumFractionDigits: 2,
                                    })
                                    : "\u00A0"
                                  }
                                </h6>
                                <h6 className="text-color fw-bold mb-0" style={{ fontSize: "18px" }}>
                                  {Number(product?.final_prices).toLocaleString('en-IN', {
                                    style: 'currency',
                                    currency: 'INR',
                                    minimumFractionDigits: 2,
                                  })}
                                </h6>
                              </div>
                            </div>

                            {product?.is_sold == 1 ? (
                              <div className="cart-btn-float" style={{ color: "#999", cursor: "not-allowed" }}>
                                <span style={{ fontSize: "10px", fontWeight: "bold" }}>SOLD</span>
                              </div>
                            ) : (
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleAddToCart(product);
                                }}
                                className="cart-btn-float"
                                title={product?.cart ? "Already in Cart" : "Add to Cart"}
                              >
                                {product?.cart ? <FaShoppingCart style={{ color: "#650020" }} /> : <HiOutlineShoppingCart />}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="w-100 d-flex justify-content-space-evenly flex-column align-items-center">
                    <img src="/assets/noData.png" alt="No Data" className="w-25" />
                    <h4>No Products found</h4>
                  </div>
                )}
              </div>

              {/* Pagination Controls */}
              {totalPages > 1 && (
                <div className="d-flex justify-content-center mt-4">
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="btn btn-light me-2"
                  >
                    Previous
                  </button>

                  {[...Array(totalPages).keys()].map((pageNumber) => (
                    <button
                      key={pageNumber}
                      onClick={() => handlePageChange(pageNumber + 1)}
                      className={`btn btn-light me-2 ${currentPage === pageNumber + 1 ? 'active' : ''}`}
                    >
                      {pageNumber + 1}
                    </button>
                  ))}

                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="btn btn-light ms-2"
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
